import {mapActions, mapGetters} from 'vuex'

export const authMixin = {
  computed: {
    ...mapGetters({
      'getAccessToken': 'auth/getAccessToken'
    })
  },
  methods: {
    ...mapActions({
      'doLogin': 'auth/doLogin',
      'logout': 'auth/logout',
      'forgotPassword': 'auth/forgotPassword',
      'resetPassword': 'auth/resetPassword'
    })
  }
}



// WEBPACK FOOTER //
// ./src/mixins/authMixin.js